import { forwardRef, type PropsWithChildren } from 'react';
import { motion } from 'framer-motion';

interface ContractItemAnimationWrapperProps extends PropsWithChildren {
  isUninitialized: boolean;
  id?: string;
}

const ContractItemAnimationWrapper = forwardRef<
  HTMLDivElement,
  ContractItemAnimationWrapperProps
>(({ children, isUninitialized, id }, ref) => {
  return (
    <motion.div
      id={id}
      ref={ref}
      className="h-32 aspect-square"
      initial={{
        opacity: 0,
        width: 0,
        scale: 1.2,
        marginRight: '-2rem',
      }}
      animate={{
        opacity: [null, 0, 1],
        width: [null, '8rem', '8rem'],
        scale: [null, 1.2, 1],
        marginRight: [null, '-2rem', 0],
      }}
      transition={{ duration: isUninitialized ? 0.6 : 0.8 }}
    >
      {children}
    </motion.div>
  );
});

export { ContractItemAnimationWrapper };
